export class SubMenuData {
    subMenuId: string;
    subMenuName: string;
    subMenuIconType: string;
    subMenuIconName: string;
    path: string;
    component: string;
    scopes: string[];
    baseSubMenuId?: string;
    orderId: number;
    subMenuChildren?: SubMenuData[];

    constructor(subMenuId: string, subMenuName: string, subMenuIconType: string, subMenuIconName: string, path: string, component: string, scopes: string[], orderId: number, baseSubMenuId?: string, subMenuChildren?: SubMenuData[]) {
        this.subMenuId = subMenuId;
        this.subMenuName = subMenuName;
        this.subMenuIconType = subMenuIconType;
        this.subMenuIconName = subMenuIconName;
        this.path = path;
        this.component = component;
        this.orderId = orderId;
        this.scopes = scopes;
        this.baseSubMenuId = baseSubMenuId;
        this.subMenuChildren = subMenuChildren;
    }
}